import { type DirectorAddressStore } from "services/director/directorAddressStore";
import { type DirectorStore } from "services/director/directorStore";
import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { DIRECTOR_FIELD_TO_QUESTION, DirectorSoleTraderQuestion } from "./directorSoleTraderConstants";

export class DirectorSoleTraderQuestionsStore extends QuestionsStore<DirectorSoleTraderQuestion> {
  protected _issueKey = IssueKey.Director;
  protected _issueFieldsToQuestions = DIRECTOR_FIELD_TO_QUESTION;

  constructor(
    private readonly _directorStore: DirectorStore,
    private readonly _directorAddressStore: DirectorAddressStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(DirectorSoleTraderQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): DirectorSoleTraderQuestion | undefined {
    const { mainDirector } = this._directorStore;

    if (!mainDirector?.firstName || !mainDirector?.lastName) {
      return DirectorSoleTraderQuestion.Name;
    }

    if (!mainDirector.dob) {
      return DirectorSoleTraderQuestion.Birthday;
    }

    const address = this._directorAddressStore.tryGetForDirector(mainDirector.id);
    if (!address) {
      return DirectorSoleTraderQuestion.Address;
    }

    if (!mainDirector.tfn) {
      return DirectorSoleTraderQuestion.TaxFileNumber;
    }

    return undefined;
  }
}
